/* ODCAF Express — custom apparel designer (based on the Print & Press designer).
   Fixed garment, color, style, quantity per size, print spots, design service. Extras are added as their own cart lines. */
(function () {
'use strict';
var SVGNS = 'http://www.w3.org/2000/svg';
var NECK_FRONT = 'M198 40 C214 70 286 70 302 40';
var NECK_BACK = 'M198 40 C214 52 286 52 302 40';
var TEE = 'L372 60 L452 138 L410 196 L372 170 L372 528 C300 538 200 538 128 528 L128 170 L90 196 L48 138 L128 60 Z';
var LONG = 'L372 60 C404 74 424 130 440 300 L462 480 L420 490 L394 300 L372 190 L372 528 C300 538 200 538 128 528 L128 190 L106 300 L80 490 L38 480 L60 300 C76 130 96 74 128 60 Z';
var SIDE_TORSO = 'M205 34 C222 22 278 22 295 34 C320 44 352 70 360 110 L372 530 C300 542 200 542 128 530 L140 110 C148 70 180 44 205 34 Z';
var SLEEVE_SHORT = 'M170 118 C168 70 206 52 250 52 C294 52 332 70 330 118 L352 250 C300 266 200 266 148 250 Z';
var SLEEVE_LONG = 'M190 118 C186 72 214 54 250 54 C286 54 314 72 310 118 L316 300 L306 486 C284 496 216 496 194 486 L184 300 Z';
var G = {
tee: {
label: 'T-shirt',
front: { under: [], body: NECK_FRONT + ' ' + TEE,
lines: ['M204 46 C220 66 280 66 296 46', 'M128 60 C140 110 138 150 128 170', 'M372 60 C360 110 362 150 372 170', 'M100 182 L60 128', 'M400 182 L440 128', 'M128 516 C200 526 300 526 372 516'] },
back: { under: [], body: NECK_BACK + ' ' + TEE,
lines: ['M204 44 C220 54 280 54 296 44', 'M128 60 C140 110 138 150 128 170', 'M372 60 C360 110 362 150 372 170', 'M100 182 L60 128', 'M400 182 L440 128', 'M128 516 C200 526 300 526 372 516'] },
sleeve: { torso: SIDE_TORSO, body: SLEEVE_SHORT, lines: ['M154 236 C200 252 300 252 346 236', 'M178 112 C178 76 210 62 250 62 C290 62 322 76 322 112', 'M205 34 C222 46 278 46 295 34', 'M132 516 C200 528 300 528 368 516'] }
},
long: {
label: 'Long sleeve',
front: { under: [], body: NECK_FRONT + ' ' + LONG,
lines: ['M204 46 C220 66 280 66 296 46', 'M128 60 C138 110 136 160 128 190', 'M372 60 C362 110 364 160 372 190', 'M42 462 L84 472', 'M458 462 L416 472', 'M128 516 C200 526 300 526 372 516'] },
back: { under: [], body: NECK_BACK + ' ' + LONG,
lines: ['M204 44 C220 54 280 54 296 44', 'M128 60 C138 110 136 160 128 190', 'M372 60 C362 110 364 160 372 190', 'M42 462 L84 472', 'M458 462 L416 472', 'M128 516 C200 526 300 526 372 516'] },
sleeve: { torso: SIDE_TORSO, body: SLEEVE_LONG, lines: ['M196 462 C220 472 280 472 304 462', 'M196 112 C194 80 218 64 250 64 C282 64 306 80 304 112', 'M205 34 C222 46 278 46 295 34', 'M132 516 C200 528 300 528 368 516'] }
},
hoodie: {
label: 'Hoodie',
front: { under: ['M186 64 C170 8 210 -4 250 -4 C290 -4 330 8 314 64 L306 96 L194 96 Z'], body: 'M192 50 C210 82 290 82 308 50 ' + LONG,
lines: ['M128 60 C138 110 136 160 128 190', 'M372 60 C362 110 364 160 372 190', 'M42 462 L84 472', 'M458 462 L416 472', 'M128 500 C200 510 300 510 372 500', 'M170 372 L330 372 L352 452 L148 452 Z', 'M232 84 L228 150', 'M268 84 L272 150'],
inner: 'M198 62 C202 22 298 22 302 62 L296 92 L204 92 Z' },
back: { under: [], body: NECK_BACK + ' ' + LONG,
lines: ['M128 60 C138 110 136 160 128 190', 'M372 60 C362 110 364 160 372 190', 'M42 462 L84 472', 'M458 462 L416 472', 'M128 500 C200 510 300 510 372 500', 'M250 6 L250 112'],
over: 'M180 58 C166 0 334 0 320 58 C318 118 182 118 180 58 Z' },
sleeve: { torso: SIDE_TORSO, body: SLEEVE_LONG, lines: ['M196 462 C220 472 280 472 304 462', 'M196 112 C194 80 218 64 250 64 C282 64 306 80 304 112', 'M205 34 C222 46 278 46 295 34', 'M132 516 C200 528 300 528 368 516'] }
}
};
/* Print areas in view units. scale = view units per inch. ref = where "top offset" is measured from. */
function areaFor(garment, loc) {
if (loc === 'front') {
if (garment === 'hoodie') return { x: 184, y: 112, w: 132, h: 168, scale: 12, topRef: 2.5, refName: 'below the neckline' };
return { x: 184, y: 98, w: 132, h: 180, scale: 12, topRef: 3, refName: 'below the collar' };
}
if (loc === 'back') {
if (garment === 'hoodie') return { x: 184, y: 128, w: 132, h: 180, scale: 12, topRef: 1, refName: 'below the hood' };
return { x: 184, y: 80, w: 132, h: 180, scale: 12, topRef: 2.5, refName: 'below the collar' };
}
if (garment === 'tee') return { x: 190, y: 96, w: 120, h: 120, scale: 30, topRef: 1.5, refName: 'below the shoulder seam' };
return { x: 197, y: 96, w: 105, h: 360, scale: 30, topRef: 1.5, refName: 'below the shoulder seam' };
}
var LOCS = ['front', 'back', 'left', 'right'];
var LOC_LABEL = { front: 'Front', back: 'Back', left: 'Left sleeve', right: 'Right sleeve' };
var SPIN = ['front', 'right', 'back', 'left'];
function luminance(hex) {
var h = hex.replace('#', '');
if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
var r = parseInt(h.substr(0, 2), 16) / 255, g = parseInt(h.substr(2, 2), 16) / 255, b = parseInt(h.substr(4, 2), 16) / 255;
return 0.2126 * r + 0.7152 * g + 0.0722 * b;
}
/* Returns SVG markup for the garment (no artwork). */
function garmentMarkup(garment, loc, color, uid) {
var d = G[garment];
var view = loc === 'front' ? d.front : loc === 'back' ? d.back : d.sleeve;
var dark = luminance(color) < 0.35;
var line = dark ? 'rgba(255,255,255,.22)' : 'rgba(13,13,26,.28)';
var edge = dark ? 'rgba(255,255,255,.28)' : 'rgba(13,13,26,.45)';
var s = '';
s += '<defs><linearGradient id="' + uid + 'sh" x1="0" x2="1" y1="0" y2="0">' +
'<stop offset="0" stop-color="#000" stop-opacity=".22"/><stop offset=".18" stop-color="#000" stop-opacity="0"/>' +
'<stop offset=".82" stop-color="#000" stop-opacity="0"/><stop offset="1" stop-color="#000" stop-opacity=".22"/></linearGradient>' +
'<radialGradient id="' + uid + 'hl" cx=".5" cy=".3" r=".7"><stop offset="0" stop-color="#fff" stop-opacity=".16"/><stop offset="1" stop-color="#fff" stop-opacity="0"/></radialGradient></defs>';
var mirror = loc === 'right' ? ' transform="translate(500 0) scale(-1 1)"' : '';
s += '<g' + mirror + '>';
if (view.torso) {
s += '<path d="' + view.torso + '" fill="' + color + '" stroke="' + edge + '" stroke-width="2"/>';
s += '<path d="' + view.torso + '" fill="#000" opacity=".2"/>';
}
(view.under || []).forEach(function (p) {
s += '<path d="' + p + '" fill="' + color + '" stroke="' + edge + '" stroke-width="2"/><path d="' + p + '" fill="#000" opacity=".12"/>';
});
if (view.inner) s += '<path d="' + view.inner + '" fill="#000" opacity=".35"/>';
s += '<path d="' + view.body + '" fill="' + color + '" stroke="' + edge + '" stroke-width="2" stroke-linejoin="round"/>';
s += '<path d="' + view.body + '" fill="url(#' + uid + 'sh)"/>';
s += '<path d="' + view.body + '" fill="url(#' + uid + 'hl)"/>';
view.lines.forEach(function (p) {
s += '<path d="' + p + '" fill="none" stroke="' + line + '" stroke-width="2" stroke-linecap="round" stroke-dasharray="' + (p.indexOf('Z') > -1 ? '0' : '0') + '"/>';
});
if (garment === 'hoodie' && loc === 'front') {
s += '<circle cx="228" cy="154" r="4" fill="' + line + '"/><circle cx="272" cy="154" r="4" fill="' + line + '"/>';
}
s += '</g>';
return s;
}
function overMarkup(garment, loc, color) {
var view = loc === 'back' ? G[garment].back : null;
if (!view || !view.over) return '';
var dark = luminance(color) < 0.35;
var edge = dark ? 'rgba(255,255,255,.28)' : 'rgba(13,13,26,.45)';
var line = dark ? 'rgba(255,255,255,.22)' : 'rgba(13,13,26,.28)';
return '<path d="' + view.over + '" fill="' + color + '" stroke="' + edge + '" stroke-width="2"/>' +
'<path d="' + view.over + '" fill="#000" opacity=".06"/><path d="M250 4 L250 110" stroke="' + line + '" stroke-width="2"/>';
}
function Designer(root) {
this.root = root;
this.cfg = JSON.parse(root.querySelector('[data-pp-config]').textContent);
this.state = { garment: this.cfg.garment || 'tee', color: this.cfg.colors[0].hex, colorName: this.cfg.colors[0].name, view: 'front', qty: 0, sizes: {}, style: '' };
this.art = {};
this.exact = {};
this.uid = 'pp' + Math.random().toString(36).slice(2, 7);
this.ref = 'AP-' + Date.now().toString(36).toUpperCase();
this.bind();
this.render();
}
Designer.prototype.$ = function (sel) { return this.root.querySelector(sel); };
Designer.prototype.$$ = function (sel) { return Array.prototype.slice.call(this.root.querySelectorAll(sel)); };
Designer.prototype.bind = function () {
var self = this;
this.svg = this.$('[data-pp-svg]');
this.gLayer = this.$('[data-pp-garment]');
this.overLayer = this.$('[data-pp-over]');
this.areaEl = this.$('[data-pp-area]');
this.artEl = this.$('[data-pp-art]');
this.frameEl = this.$('[data-pp-frame]');
this.handleEl = this.$('[data-pp-handle]');
this.stage = this.$('[data-pp-stage]');
this.$$('[data-pp-garment-btn]').forEach(function (b) {
b.addEventListener('click', function () { self.setGarment(b.getAttribute('data-pp-garment-btn')); });
});
this.$$('[data-pp-color]').forEach(function (b) {
b.addEventListener('click', function () {
self.state.color = b.getAttribute('data-pp-color');
self.state.colorName = b.getAttribute('data-pp-color-name');
self.render();
});
});
var custom = this.$('[data-pp-color-custom]');
if (custom) custom.addEventListener('input', function () { self.state.color = custom.value; self.state.colorName = 'Custom (' + custom.value + ')'; self.render(); });
this.$$('[data-pp-view]').forEach(function (b) {
b.addEventListener('click', function () { self.setView(b.getAttribute('data-pp-view')); });
});
if (this.$('[data-pp-prev]')) this.$('[data-pp-prev]').addEventListener('click', function () { self.step(-1); });
if (this.$('[data-pp-next]')) this.$('[data-pp-next]').addEventListener('click', function () { self.step(1); });
if (this.$('[data-pp-spin]')) this.$('[data-pp-spin]').addEventListener('click', function () { self.spin(); });
LOCS.forEach(function (loc) {
var card = self.$('[data-pp-loc="' + loc + '"]');
if (!card) return;
var input = card.querySelector('input[type=file]');
input.addEventListener('change', function () { if (input.files[0]) self.load(loc, input.files[0]); input.value = ''; });
card.querySelector('[data-pp-pick]').addEventListener('click', function () { input.click(); });
card.querySelector('[data-pp-remove]').addEventListener('click', function () { self.remove(loc); });
card.querySelector('[data-pp-size]').addEventListener('input', function (e) { self.resize(loc, parseFloat(e.target.value)); });
var ex = card.querySelector('[data-pp-exact]'), ew = card.querySelector('[data-pp-exact-w]'), eh = card.querySelector('[data-pp-exact-h]');
ex.addEventListener('change', function () {
self.exact[loc] = ex.checked;
if (ex.checked) { var i = self.info(loc); if (i) { ew.value = i.wIn.toFixed(1); eh.value = i.hIn.toFixed(1); } }
self.syncCard(loc);
});
ew.addEventListener('change', function () { self.exactSet(loc, 'w', parseFloat(ew.value)); });
eh.addEventListener('change', function () { self.exactSet(loc, 'h', parseFloat(eh.value)); });
card.addEventListener('click', function (e) { if (!e.target.closest('input, button')) self.setView(loc); });
card.addEventListener('dragover', function (e) { e.preventDefault(); card.classList.add('is-drag'); });
card.addEventListener('dragleave', function () { card.classList.remove('is-drag'); });
card.addEventListener('drop', function (e) {
e.preventDefault(); card.classList.remove('is-drag');
if (e.dataTransfer.files[0]) self.load(loc, e.dataTransfer.files[0]);
});
});
this.stage.addEventListener('dragover', function (e) { e.preventDefault(); });
this.stage.addEventListener('drop', function (e) {
e.preventDefault();
if (e.dataTransfer.files[0]) self.load(self.state.view, e.dataTransfer.files[0]);
});
var drag = null;
function pt(e) {
var p = self.svg.createSVGPoint(); p.x = e.clientX; p.y = e.clientY;
return p.matrixTransform(self.svg.getScreenCTM().inverse());
}
this.artEl.addEventListener('pointerdown', function (e) {
var a = self.art[self.state.view]; if (!a) return;
e.preventDefault(); self.artEl.setPointerCapture(e.pointerId);
var p = pt(e); drag = { mode: 'move', ox: p.x - a.x, oy: p.y - a.y, id: e.pointerId, el: self.artEl };
});
this.handleEl.addEventListener('pointerdown', function (e) {
var a = self.art[self.state.view]; if (!a || self.exact[self.state.view]) return;
e.preventDefault(); e.stopPropagation(); self.handleEl.setPointerCapture(e.pointerId);
drag = { mode: 'size', id: e.pointerId, el: self.handleEl };
});
function move(e) {
if (!drag || e.pointerId !== drag.id) return;
var loc = self.state.view, a = self.art[loc]; if (!a) return;
var ar = areaFor(self.state.garment, loc), p = pt(e);
if (drag.mode === 'move') {
a.x = p.x - drag.ox; a.y = p.y - drag.oy;
} else {
var w = Math.max(ar.scale * 1, p.x - a.x);
a.w = w; a.h = w * a.ratio;
}
self.clamp(loc); self.drawArt(); self.syncCard(loc);
}
function up(e) { if (drag && e.pointerId === drag.id) { drag = null; self.update(); } }
this.artEl.addEventListener('pointermove', move);
this.handleEl.addEventListener('pointermove', move);
this.artEl.addEventListener('pointerup', up);
this.handleEl.addEventListener('pointerup', up);
this.artEl.addEventListener('pointercancel', up);
this.handleEl.addEventListener('pointercancel', up);
this.$$('[data-pp-preset]').forEach(function (b) {
b.addEventListener('click', function (e) {
e.stopPropagation();
var loc = b.closest('[data-pp-loc]').getAttribute('data-pp-loc');
self.preset(loc, b.getAttribute('data-pp-preset'));
});
});
/* style, sizes, design service */
this.$$('[data-ap-style]').forEach(function (r) {
r.addEventListener('change', function () { self.state.style = r.value; self.update(); });
if (r.checked) self.state.style = r.value;
});
function readSizes() {
var total = 0; self.state.sizes = {};
self.$$('[data-ap-size]').forEach(function (i) {
var n = Math.max(0, Math.min(999, parseInt(i.value, 10) || 0));
if (String(n) !== i.value && i.value !== '') i.value = n;
if (n) { self.state.sizes[i.getAttribute('data-ap-size')] = n; total += n; }
});
self.state.qty = total; self.update();
}
this.$$('[data-ap-size]').forEach(function (i) { i.addEventListener('input', readSizes); });
this.$$('[data-ap-step]').forEach(function (b) {
b.addEventListener('click', function () {
var i = b.parentNode.querySelector('[data-ap-size]');
i.value = Math.max(0, (parseInt(i.value, 10) || 0) + (+b.getAttribute('data-ap-step'))); readSizes();
});
});
readSizes();
var dz = this.$('[data-ap-design]');
if (dz) dz.addEventListener('change', function () {
var more = self.$('[data-ap-design-more]'); if (more) more.hidden = !dz.checked;
self.update();
});
this.$('[data-pp-submit]').addEventListener('click', function () { self.submit(); });
};
Designer.prototype.iso = function (d) {
var m = d.getMonth() + 1, day = d.getDate();
return d.getFullYear() + '-' + (m < 10 ? '0' : '') + m + '-' + (day < 10 ? '0' : '') + day;
};
Designer.prototype.parseDate = function (s) { var p = s.split('-'); return new Date(+p[0], +p[1] - 1, +p[2]); };
Designer.prototype.isClosed = function (d) { return this.cfg.closedDays.indexOf(d.getDay()) > -1; };
Designer.prototype.nextOpen = function (d) {
var n = new Date(d.getTime());
for (var i = 0; i < 10; i++) { n.setDate(n.getDate() + 1); if (!this.isClosed(n)) return n; }
return n;
};
Designer.prototype.fmtDate = function (d) {
return d.toLocaleDateString(undefined, { weekday: 'long', month: 'long', day: 'numeric' });
};
Designer.prototype.setGarment = function (g) {
var old = this.state.garment; this.state.garment = g;
var self = this;
LOCS.forEach(function (loc) {
var a = self.art[loc]; if (!a) return;
var oa = areaFor(old, loc), na = areaFor(g, loc);
var wIn = a.w / oa.scale, cxIn = (a.x + a.w / 2 - (oa.x + oa.w / 2)) / oa.scale, topIn = (a.y - oa.y) / oa.scale;
a.w = wIn * na.scale; a.h = a.w * a.ratio;
a.x = na.x + na.w / 2 + cxIn * na.scale - a.w / 2; a.y = na.y + topIn * na.scale;
self.clamp(loc);
});
this.render();
};
Designer.prototype.setView = function (v) { this.state.view = v; this.render(); };
Designer.prototype.step = function (dir) {
var i = SPIN.indexOf(this.state.view);
this.flip(SPIN[(i + dir + SPIN.length) % SPIN.length], dir);
};
Designer.prototype.flip = function (to, dir, cb) {
var self = this, st = this.stage;
st.style.transition = 'transform .22s ease-in';
st.style.transform = 'perspective(900px) rotateY(' + (dir > 0 ? -90 : 90) + 'deg)';
setTimeout(function () {
self.setView(to);
st.style.transition = 'none';
st.style.transform = 'perspective(900px) rotateY(' + (dir > 0 ? 90 : -90) + 'deg)';
void st.offsetWidth;
st.style.transition = 'transform .22s ease-out';
st.style.transform = 'perspective(900px) rotateY(0deg)';
setTimeout(function () { if (cb) cb(); }, 240);
}, 220);
};
Designer.prototype.spin = function () {
if (this.spinning) return;
this.spinning = true;
var self = this, start = SPIN.indexOf(this.state.view), n = 0;
var btn = this.$('[data-pp-spin]'); btn.disabled = true;
function next() {
n++;
if (n > SPIN.length) { self.spinning = false; btn.disabled = false; return; }
setTimeout(function () { self.flip(SPIN[(start + n) % SPIN.length], 1, next); }, 450);
}
next();
};
Designer.prototype.load = function (loc, file) {
var self = this, card = this.$('[data-pp-loc="' + loc + '"]');
var err = card.querySelector('[data-pp-err]');
err.textContent = '';
var okType = /^image\/(png|jpe?g|webp)$/i.test(file.type);
if (!okType) { err.textContent = 'Please upload a PNG, JPG or WEBP image.'; return; }
if (file.size > this.cfg.maxMb * 1024 * 1024) { err.textContent = 'That file is over ' + this.cfg.maxMb + ' MB. Please upload a smaller file or call us.'; return; }
var url = URL.createObjectURL(file);
var img = new Image();
img.onload = function () {
if (self.art[loc] && self.art[loc].url) URL.revokeObjectURL(self.art[loc].url);
var ar = areaFor(self.state.garment, loc);
var ratio = img.naturalHeight / img.naturalWidth;
var defIn = loc === 'front' ? self.cfg.defaultFront : loc === 'back' ? self.cfg.defaultBack : self.cfg.defaultSleeve;
var w = Math.min(defIn * ar.scale, ar.w, ar.h / ratio);
self.art[loc] = { file: file, url: url, img: img, natW: img.naturalWidth, natH: img.naturalHeight, ratio: ratio,
w: w, h: w * ratio, x: ar.x + (ar.w - w) / 2, y: ar.y };
self.state.view = loc;
self.render();
};
img.onerror = function () { err.textContent = 'We couldn’t read that image. Try saving it as PNG or JPG.'; URL.revokeObjectURL(url); };
img.src = url;
};
Designer.prototype.remove = function (loc) {
var a = this.art[loc];
if (a && a.url) URL.revokeObjectURL(a.url);
delete this.art[loc];
this.exact[loc] = false;
var c = this.$('[data-pp-loc="' + loc + '"]');
c.querySelector('[data-pp-exact]').checked = false;
c.querySelector('[data-pp-exact-w]').value = ''; c.querySelector('[data-pp-exact-h]').value = '';
this.render();
};
Designer.prototype.clamp = function (loc) {
var a = this.art[loc]; if (!a) return;
var ar = areaFor(this.state.garment, loc);
var maxW = Math.min(ar.w, ar.h / a.ratio);
if (a.w > maxW) { a.w = maxW; a.h = a.w * a.ratio; }
a.x = Math.min(Math.max(a.x, ar.x), ar.x + ar.w - a.w);
a.y = Math.min(Math.max(a.y, ar.y), ar.y + ar.h - a.h);
};
Designer.prototype.resize = function (loc, wIn) {
var a = this.art[loc]; if (!a) return;
var ar = areaFor(this.state.garment, loc);
var cx = a.x + a.w / 2;
a.w = wIn * ar.scale; a.h = a.w * a.ratio;
a.x = cx - a.w / 2;
this.clamp(loc);
if (this.state.view !== loc) this.setView(loc); else { this.drawArt(); this.syncCard(loc); this.update(); }
};
Designer.prototype.exactSet = function (loc, dim, v) {
var a = this.art[loc], card = this.$('[data-pp-loc="' + loc + '"]');
var err = card.querySelector('[data-pp-err]'); err.textContent = '';
if (!a || !(v > 0)) return;
var ar = areaFor(this.state.garment, loc), maxW = ar.w / ar.scale, maxH = ar.h / ar.scale;
var w = dim === 'w' ? v : v / a.ratio, h = w * a.ratio;
if (w > maxW + 0.001 || h > maxH + 0.001) {
err.textContent = 'Too big for this spot — the maximum here is ' + (+maxW.toFixed(1)) + '″ wide × ' + (+maxH.toFixed(1)) + '″ tall with your artwork’s proportions.';
var i0 = this.info(loc);
card.querySelector('[data-pp-exact-w]').value = i0.wIn.toFixed(1); card.querySelector('[data-pp-exact-h]').value = i0.hIn.toFixed(1);
return;
}
var cx = a.x + a.w / 2;
a.w = w * ar.scale; a.h = a.w * a.ratio; a.x = cx - a.w / 2;
this.clamp(loc);
card.querySelector('[data-pp-exact-w]').value = (+w.toFixed(2));
card.querySelector('[data-pp-exact-h]').value = (+h.toFixed(2));
if (this.state.view !== loc) this.setView(loc); else { this.drawArt(); this.syncCard(loc); this.update(); }
};
Designer.prototype.preset = function (loc, name) {
var a = this.art[loc]; if (!a) return;
if (this.exact[loc]) { var em = this.$('[data-pp-loc="' + loc + '"] [data-pp-err]'); em.textContent = 'Exact size is on — turn it off to use presets.'; return; }
var ar = areaFor(this.state.garment, loc), s = ar.scale, wIn = 4, cx = 0, top = 0;
if (name === 'full') { wIn = 11; }
else if (name === 'center') { wIn = 4; }
else if (name === 'lchest') { wIn = 3.5; cx = 3.2; top = 0.5; }
else if (name === 'rchest') { wIn = 3.5; cx = -3.2; top = 0.5; }
else if (name === 'upper') { wIn = 10; }
else if (name === 'sleeve') { wIn = 3; }
else if (name === 'down') { wIn = 2.5; }
a.w = wIn * s; a.h = a.w * a.ratio;
this.clamp(loc);
a.x = ar.x + ar.w / 2 + cx * s - a.w / 2; a.y = ar.y + top * s;
this.clamp(loc);
this.setView(loc);
};
Designer.prototype.info = function (loc) {
var a = this.art[loc]; if (!a) return null;
var ar = areaFor(this.state.garment, loc);
var wIn = a.w / ar.scale, hIn = a.h / ar.scale;
var dx = (a.x + a.w / 2 - (ar.x + ar.w / 2)) / ar.scale;
var topIn = ar.topRef + (a.y - ar.y) / ar.scale;
var dpi = Math.round(a.natW / wIn);
var horiz = Math.abs(dx) < 0.25 ? 'centered' : (Math.abs(dx).toFixed(1) + '″ ' + (dx < 0 ? 'left' : 'right') + ' of center (as viewed)');
return { wIn: wIn, hIn: hIn, dpi: dpi,
size: wIn.toFixed(1) + '″ W × ' + hIn.toFixed(1) + '″ H',
pos: horiz.charAt(0).toUpperCase() + horiz.slice(1) + ' · top ' + topIn.toFixed(1) + '″ ' + ar.refName };
};
Designer.prototype.drawArt = function () {
var loc = this.state.view, a = this.art[loc];
var ar = areaFor(this.state.garment, loc);
var ax = ar.x, aw = ar.w;
this.areaEl.setAttribute('x', ax); this.areaEl.setAttribute('y', ar.y);
this.areaEl.setAttribute('width', aw); this.areaEl.setAttribute('height', ar.h);
this.stage.classList.toggle('has-art', !!a);
if (!a) {
this.artEl.setAttribute('width', 0); this.frameEl.setAttribute('width', 0);
this.handleEl.setAttribute('r', 0);
return;
}
this.artEl.setAttribute('href', a.url);
this.artEl.setAttribute('x', a.x); this.artEl.setAttribute('y', a.y);
this.artEl.setAttribute('width', a.w); this.artEl.setAttribute('height', a.h);
this.frameEl.setAttribute('x', a.x); this.frameEl.setAttribute('y', a.y);
this.frameEl.setAttribute('width', a.w); this.frameEl.setAttribute('height', a.h);
this.handleEl.setAttribute('cx', a.x + a.w); this.handleEl.setAttribute('cy', a.y + a.h);
this.handleEl.setAttribute('r', loc === 'front' || loc === 'back' ? 7 : 9);
var i = this.info(loc);
this.$('[data-pp-readout]').textContent = LOC_LABEL[loc] + ': ' + i.size + ' · ' + i.pos;
};
Designer.prototype.syncCard = function (loc) {
var card = this.$('[data-pp-loc="' + loc + '"]'), a = this.art[loc];
if (!card) return;
card.classList.toggle('has-art', !!a);
card.classList.toggle('is-active', this.state.view === loc);
card.classList.toggle('is-exact', !!this.exact[loc]);
if (!a) return;
card.querySelector('[data-pp-size]').disabled = !!this.exact[loc];
var i = this.info(loc), ar = areaFor(this.state.garment, loc);
var slider = card.querySelector('[data-pp-size]');
slider.max = (Math.min(ar.w, ar.h / a.ratio) / ar.scale).toFixed(1);
slider.value = i.wIn.toFixed(1);
card.querySelector('[data-pp-thumb]').src = a.url;
card.querySelector('[data-pp-fname]').textContent = a.file.name;
card.querySelector('[data-pp-sizeout]').textContent = i.size;
var q = card.querySelector('[data-pp-quality]');
var level = i.dpi >= 250 ? 'good' : i.dpi >= 150 ? 'ok' : 'low';
q.className = 'pp-q pp-q--' + level;
q.textContent = level === 'good' ? 'Great quality' : level === 'ok' ? 'Good quality' : 'Low resolution — may print blurry';
q.title = '≈ ' + i.dpi + ' DPI at this size';
};
Designer.prototype.render = function () {
var s = this.state, self = this;
this.gLayer.innerHTML = garmentMarkup(s.garment, s.view, s.color, this.uid);
this.overLayer.innerHTML = overMarkup(s.garment, s.view, s.color);
var dark = luminance(s.color) < 0.35;
this.stage.classList.toggle('is-dark', dark);
this.$$('[data-pp-garment-btn]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-pp-garment-btn') === s.garment); });
this.$$('[data-pp-color]').forEach(function (b) { b.classList.toggle('is-on', b.getAttribute('data-pp-color') === s.color); });
this.$$('[data-pp-view]').forEach(function (b) {
var v = b.getAttribute('data-pp-view');
b.classList.toggle('is-on', v === s.view);
b.classList.toggle('has-art', !!self.art[v]);
});
this.$('[data-pp-garment-name]').textContent = (this.cfg.garmentLabel || G[s.garment].label) + ' · ' + s.colorName;
this.$('[data-pp-viewname]').textContent = LOC_LABEL[s.view];
this.drawArt();
if (!this.art[s.view]) this.$('[data-pp-readout]').textContent = 'No design on the ' + LOC_LABEL[s.view].toLowerCase() + ' yet — upload one to see it here.';
LOCS.forEach(function (l) { self.syncCard(l); });
this.update();
};
Designer.prototype.pricing = function () {
var has = {}, self = this, A = this.cfg.addons || {}, s = this.state, n = s.qty;
LOCS.forEach(function (l) { has[l] = !!self.art[l]; });
var main = (has.front ? 1 : 0) + (has.back ? 1 : 0);
var sleeves = (has.left ? 1 : 0) + (has.right ? 1 : 0);
var lines = [];
lines.push({ label: (this.cfg.garmentLabel || 'Garment') + ' × ' + n, price: this.cfg.base.price * n });
var items = [];
function add(key, qty, label) {
var a = A[key]; if (!a || !a.id || !qty) return;
items.push({ id: a.id, quantity: qty });
lines.push({ label: label + ' × ' + qty, price: a.price * qty });
}
if (main === 2) add('back', n, A.back ? A.back.label : 'Back print');
if (sleeves) add('sleeve', n * sleeves, A.sleeve ? A.sleeve.label : 'Sleeve print');
(this.cfg.sizes || []).forEach(function (z) { if (z.addon && s.sizes[z.name]) add(z.addon, s.sizes[z.name], 'Size ' + z.name); });
var dz = this.$('[data-ap-design]');
if (dz && dz.checked && this.cfg.design && this.cfg.design.id) {
items.push({ id: this.cfg.design.id, quantity: 1 });
lines.push({ label: 'Design service', price: this.cfg.design.price });
}
var total = lines.reduce(function (t, l) { return t + l.price; }, 0);
return { count: main + sleeves, lines: lines, items: items, total: total };
};
Designer.prototype.money = function (cents) {
try { return new Intl.NumberFormat(undefined, { style: 'currency', currency: this.cfg.currency }).format(cents / 100); }
catch (e) { return '$' + (cents / 100).toFixed(2); }
};
Designer.prototype.update = function () {
var p = this.pricing(), self = this;
var em = this.$('[data-pp-msg]'); if (em && em.classList.contains('is-err') && !this.submitting) { em.textContent = ''; em.className = 'pp-msg'; }
this.$('[data-pp-lines]').innerHTML = p.lines.map(function (l) { return '<li><span>' + l.label + '</span><b>' + self.money(l.price) + '</b></li>'; }).join('');
this.$('[data-ap-total]').textContent = this.money(p.total);
this.$('[data-pp-count]').textContent = p.count ? (p.count + (p.count === 1 ? ' print location' : ' print locations')) : 'No designs yet';
var tq = this.$('[data-ap-total-qty]'); if (tq) tq.textContent = this.state.qty ? this.state.qty + (this.state.qty === 1 ? ' garment' : ' garments') : 'No sizes yet';
var bt = this.$('[data-pp-submit] > span'); if (bt) bt.textContent = this.state.qty ? 'Add to cart · ' + this.money(p.total) : 'Add to cart';
};
Designer.prototype.validate = function () {
var s = this.state, p = this.pricing(), self = this;
var dz = this.$('[data-ap-design]'), designing = dz && dz.checked;
if (!s.qty) return 'Enter how many you need in each size.';
var lk = this.$('[data-ap-link]'), lv = lk ? lk.value.trim() : '';
if (lv && !/^https?:\/\//i.test(lv) && /\./.test(lv)) { lv = 'https://' + lv; lk.value = lv; }
if (lv && !/^https?:\/\/[^\s.]+\.[^\s]{2,}/i.test(lv)) return 'Please paste the full link to your file, starting with https://';
if (!p.count && !designing && !lv) return 'Upload at least one design, paste a link to it, or choose “Design it for me”.';
var missing = LOCS.filter(function (l) { return self.art[l] && self.exact[l] && !(parseFloat(self.$('[data-pp-loc="' + l + '"] [data-pp-exact-w]').value) > 0); });
if (missing.length) return 'Enter the exact size for your ' + missing.map(function (l) { return LOC_LABEL[l]; }).join(' and ') + ' design, or turn Exact size off.';
var low = [];
LOCS.forEach(function (l) { var i = self.info(l); if (i && i.dpi < 100) low.push(LOC_LABEL[l]); });
if (low.length && !this.lowOk) {
this.lowOk = true;
return 'Heads up: your ' + low.join(' and ') + ' design is low resolution at this size and may print blurry. Make it smaller or upload a sharper file — or press Add to cart again to continue anyway.';
}
return '';
};
/* Renders one location to a PNG blob for the order. */
Designer.prototype.preview = function (loc) {
var self = this, s = this.state, a = this.art[loc];
return new Promise(function (resolve) {
var W = 1000, H = 1120, k = 2;
var svg = '<svg xmlns="' + SVGNS + '" viewBox="0 0 500 560" width="' + W + '" height="' + H + '">' +
'<rect width="500" height="560" fill="#f4f5f8"/>' + garmentMarkup(s.garment, loc, s.color, 'x' + loc) + '</svg>';
var over = overMarkup(s.garment, loc, s.color);
var gi = new Image();
gi.onload = function () {
var c = document.createElement('canvas'); c.width = W; c.height = H;
var ctx = c.getContext('2d');
ctx.drawImage(gi, 0, 0, W, H);
if (a) ctx.drawImage(a.img, a.x * k, a.y * k, a.w * k, a.h * k);
function finish() {
ctx.fillStyle = 'rgba(13,13,26,.75)'; ctx.font = 'bold 26px sans-serif';
ctx.fillText(LOC_LABEL[loc] + (a ? ' — ' + self.info(loc).size : ''), 24, H - 28);
c.toBlob(function (b) { resolve(b); }, 'image/png');
}
if (over) {
var oi = new Image();
oi.onload = function () { ctx.drawImage(oi, 0, 0, W, H); finish(); };
oi.onerror = finish;
oi.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent('<svg xmlns="' + SVGNS + '" viewBox="0 0 500 560" width="' + W + '" height="' + H + '">' + over + '</svg>');
} else finish();
};
gi.onerror = function () { resolve(null); };
gi.src = 'data:image/svg+xml;charset=utf-8,' + encodeURIComponent(svg);
});
};
Designer.prototype.submit = function () {
var self = this, s = this.state, msg = this.$('[data-pp-msg]'), btn = this.$('[data-pp-submit]');
var err = this.validate();
msg.className = 'pp-msg';
if (err) { msg.textContent = err; msg.classList.add('is-err'); return; }
this.lowOk = false;
btn.disabled = true; btn.classList.add('is-loading');
msg.textContent = 'Uploading your files — this can take a moment for large images…';
var locs = LOCS.filter(function (l) { return self.art[l]; });
Promise.all(locs.map(function (l) { return self.preview(l); })).then(function (blobs) {
var fd = new FormData();
fd.append('id', self.cfg.base.id);
fd.append('quantity', s.qty);
fd.append('properties[Color]', s.colorName);
if (s.style) fd.append('properties[' + (self.cfg.styleLabel || 'Style') + ']', s.style);
fd.append('properties[Sizes]', (self.cfg.sizes || []).filter(function (z) { return s.sizes[z.name]; }).map(function (z) { return z.name + ' × ' + s.sizes[z.name]; }).join(', '));
if (locs.length) fd.append('properties[Print locations]', locs.map(function (l) { return LOC_LABEL[l]; }).join(', '));
locs.forEach(function (l, i) {
var info = self.info(l), name = LOC_LABEL[l];
fd.append('properties[' + name + ' artwork]', self.art[l].file, self.art[l].file.name);
fd.append('properties[' + name + ' size]', info.size + (self.exact[l] ? ' — EXACT SIZE REQUIRED' : ' (standard sizing)'));
fd.append('properties[' + name + ' position]', info.pos);
if (blobs[i]) fd.append('properties[' + name + ' preview]', blobs[i], self.ref + '-' + l + '-preview.png');
});
var dz = self.$('[data-ap-design]');
if (dz && dz.checked) {
fd.append('properties[Design service]', 'Yes — design it for me');
var dd = self.$('[data-ap-design-notes]'); if (dd && dd.value.trim()) fd.append('properties[Design details]', dd.value.trim());
}
var lk = self.$('[data-ap-link]'); if (lk && lk.value.trim()) fd.append('properties[Artwork link]', lk.value.trim());
var notes = self.$('[data-pp-notes]').value.trim();
if (notes) fd.append('properties[Special instructions]', notes);
fd.append('properties[_Order ref]', self.ref);
return fetch(self.cfg.addUrl, { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
}).then(function (r) {
return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || j.message || 'Could not add to cart'); return j; });
}).then(function () {
var p = self.pricing();
if (!p.items.length) return null;
var items = p.items.map(function (it) { return { id: it.id, quantity: it.quantity, properties: { 'For': self.cfg.title + ' ' + self.ref, '_Order ref': self.ref } }; });
return fetch(self.cfg.addUrl, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: items }) })
.then(function (r) { return r.json().then(function (j) { if (!r.ok || j.status) throw new Error(j.description || 'Could not add the extras'); return j; }); });
}).then(function () {
msg.textContent = 'Added! Taking you to your cart…';
window.location.href = self.cfg.cartUrl;
}).catch(function (e) {
btn.disabled = false; btn.classList.remove('is-loading');
msg.classList.add('is-err');
msg.textContent = (e && e.message ? e.message + '. ' : '') + 'Please try again, or call us at ' + self.cfg.phone + '.';
});
};
function init() {
Array.prototype.forEach.call(document.querySelectorAll('[data-ap-root]'), function (el) {
if (!el.__ap) el.__ap = new Designer(el);
});
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
document.addEventListener('shopify:section:load', init);
})();
